module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setHwInfo"
  }, [_c('el-form', [_c('el-form-item', [_c('el-table', {
    attrs: {
      "data": _vm.hwInfoData,
      "cell-style": {
        textAlign: 'center'
      },
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      }
    },
    on: {
      "select": _vm.handleSelect,
      "select-all": _vm.handleSelectAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _vm._l((_vm.colConfigs), function(ref) {
    var prop = ref.prop;
    var label = ref.label;

    return _c('el-table-column', {
      key: prop,
      attrs: {
        "prop": prop,
        "label": label
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": ""
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6368c3b5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetHwInfo.vue
// module id = W8Tw
// module chunks = 1